import { Briefcase, Building2, Users, FileText, Globe } from "lucide-react";
import HubLayout from "./HubLayout";

export default function Career() {
  return (
    <HubLayout
      eyebrow="Career"
      headline="Speak English that"
      italic="gets you hired."
      subhead="Job interviews, office WhatsApp, the salary conversation. The English that actually moves your career — not generic textbook English."
      cards={[
        {
          Icon: Briefcase, accent: "var(--rust)",
          title: "Interview practice",
          lede: "HR, technical, case, stress — the four rounds every cycle runs through. Question banks and speaking prompts.",
          to: "/career/interview",
        },
        {
          Icon: Building2, accent: "var(--gold-500)",
          title: "Office English",
          lede: "Standups, polite pushback, meeting interjections, email tone. Do-say versus don't-say, paired.",
          to: "/career/office",
        },
        {
          Icon: Users, accent: "var(--sky)",
          title: "Group discussion",
          lede: "GD practice with timing, turn-taking, structured opinion phrases. Coming this month.",
          status: "soon",
        },
        {
          Icon: FileText, accent: "var(--sage)",
          title: "Resume English",
          lede: "Action verbs, quantified bullets, the words recruiters actually search for.",
          status: "soon",
        },
        {
          Icon: Globe, accent: "var(--ink-700)",
          title: "LinkedIn writing",
          lede: "Headline that lands. About section that opens doors. Connect notes that don't get ignored.",
          status: "soon",
        },
      ]}
    />
  );
}
